// extracted by mini-css-extract-plugin
export default {"contents":"WG-z","sectionHeading":"XG-z"};